export * from './store'
export * from './menu.component'



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/index.ts